<template>
  <div class="register">
    <v-stepper class="stepper" v-model="selectedStep" dark>
      <v-stepper-header>
        <v-stepper-step color="green" step="1">Vereinsdaten</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="2">Leitung</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="3">Wappen</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="4">Bedarf</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="5" complete>Saisonticket</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items class="items">
        <v-stepper-content class="content" step="1">
          <h1>
            Damit wir passende Spieler oder Trainer für
            <span class="green-text">euren</span> Verein finden können, benötigen wir
            noch einige wichtige Infos von euch.
          </h1>

          <hr class="green-line" />

          <label>
            Ansässig in Land
            <span>*</span>
          </label>
          <v-select
            v-model="user_data.nationality"
            :items="$store.state.nationalities"
            item-text="item_text"
            item-value="id"
            color="green"
            solo
          >
            <template v-slot:item="slotProps">
              <i
                :class="['mr-2', 'em', `em-flag-${slotProps.item.id.toLowerCase()}`]"
              ></i>
              {{ slotProps.item.item_text }}
            </template>
          </v-select>

          <label>
            Region/Verband
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="$store.state.verband"
            v-model="user_data.verband"
            solo
          ></v-select>

          <label v-if="user_data.verband">
            Aktuelle Liga
            <span>*</span>
          </label>
          <v-select
            v-if="user_data.verband"
            color="green"
            :items="$store.state.filter_leagues[user_data.verband]"
            item-text="league"
            item-value="category"
            return-object
            v-model="user_data.category"
            solo
          ></v-select>

          <v-btn
            color="green white--text"
            :disabled="
              user_data.verband == '' ||
              user_data.nationality == '' ||
              !user_data.category
            "
            @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="2">
          <label>
            Vereinsvorsitzende/r
            <span>*</span>
          </label>
          <v-text-field
            placeholder="Vor- und Nachname"
            color="green"
            v-model="user_data.ceo"
            solo
          />
          <label>
            Sportliche/r Leiter/in
            <span>*</span>
          </label>
          <v-text-field
            placeholder="Vor- und Nachname"
            color="green"
            v-model="user_data.sportlicher_leiter"
            solo
          />
          <label>
            Cheftrainer/in
            <span>*</span>
          </label>
          <v-text-field
            placeholder="Vor- und Nachname"
            color="green"
            v-model="user_data.cheftrainer"
            solo
          />
          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :disabled="
              !user_data.ceo || !user_data.cheftrainer || !user_data.sportlicher_leiter
            "
            @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="3">
          <div v-if="user_data.big_thumbnail" class="upload-change-wrapper">
            <img
              class="register-avatar register-avatar__big"
              :src="user_data.big_thumbnail"
              alt=""
            />
            <label class="upload-label" for="upload-photo"
              ><b class="green-text">Vereinswappen</b> hochladen</label
            >
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>
          <div v-else class="upload-wrapper">
            <label class="upload-label" for="upload-photo"
              ><b class="green-text">Vereinswappen</b> hochladen</label
            >
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>

          <br />
          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" :disabled="!imageSrc" @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="4">
          <label>
            Aktueller Spieler-/Trainerbedarf
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="need"
            v-model="user_data.will_be_found_by"
            solo
          ></v-select>

          <div class="range-slide" v-if="isPlayerNeeded">
            <h1>Spielerattribute</h1>

            <label
              >Alter (von {{ user_data.playerAgeRange[0] }} bis
              {{ user_data.playerAgeRange[1] }})</label
            >
            <v-range-slider
              solo
              class="age-slider"
              color="green"
              v-model="user_data.playerAgeRange"
              :min="14"
              :max="40"
            ></v-range-slider>
            <label>Geschlecht <span>*</span></label>
            <v-select
              color="green"
              :items="$store.state.sex"
              v-model="user_data.playerprofile_sex"
              multiple
              solo
            ></v-select>

            <label>Position <span>*</span></label>
            <v-select
              color="green"
              :items="$store.state.positions"
              v-model="user_data.playerprofile_position"
              solo
              multiple
            ></v-select>
          </div>

          <div v-if="isTrainerNeeded">
            <h1>Trainerattribute</h1>
            <label
              >Alter (von {{ user_data.trainerAgeRange[0] }} bis
              {{ user_data.trainerAgeRange[1] }})</label
            >
            <v-range-slider
              solo
              class="age-slider"
              color="green"
              v-model="user_data.trainerAgeRange"
              :min="14"
              :max="80"
            ></v-range-slider>
            <label>Geschlecht <span>*</span></label>
            <v-select
              color="green"
              :items="$store.state.sex"
              v-model="user_data.trainerprofile_sex"
              solo
              multiple
            ></v-select>

            <label>Trainertyp <span>*</span></label>
            <v-select
              color="green"
              multiple
              :items="$store.state.trainer_types"
              v-model="user_data.trainerprofile_type"
              solo
            ></v-select>
          </div>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" @click="next" :disabled="!isFormValid"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="5">
          <h1>
            Mit dem <span class="green-text">C4T-Saisonticket</span><span>*</span> könnt
            ihr während der gesamten Laufzeit unbegrenzt Spieler und Trainer matchen -
            so funktioniert heutzutage effiziente Kaderplanung & digitales
            Talentscouting.
          </h1>
          <p>
            Die nachfolgenden Preise beziehen sich auf eine ganze Saison (12 Monate) und
            sind Liga abhängig.
          </p>

          <table class="table-price">
            <tr>
              <td class="text-left">Regionalliga</td>
              <td class="text-right">1.299,00 €</td>
            </tr>
            <tr>
              <td class="text-left">Oberliga</td>
              <td class="text-right">799,00 €</td>
            </tr>
            <tr>
              <td class="text-left">Verbandsliga</td>
              <td class="text-right">499,00 €</td>
            </tr>
            <tr>
              <td class="text-left">Landesliga</td>
              <td class="text-right">299,00 €</td>
            </tr>
            <tr>
              <td class="text-left">Landesklasse</td>
              <td class="text-right">199,00 €</td>
            </tr>
            <tr>
              <td class="text-left">Kreisebene</td>
              <td class="text-right">149,00 €</td>
            </tr>
            <tr>
              <th colspan="2" class="text-right">Preise sind inkl. ges. MwSt.</th>
            </tr>
          </table>

          <p class="mt-3">* Das Saisonticket ist später <u>optional</u> buchbar.</p>
          <h2 class="middle_header">
            Ihr wollt mehr über die exklusiven Vorteile des C4T-Saisontickets erfahren?
            Dann lasst euch ganz einfach von unserem kompetenten Sales-Team anrufen.
          </h2>

          <div class="row">
            <div style="display: inline-block">
              <v-radio-group
                v-model="user_data.contact_needed"
                color="green"
                :column="false"
              >
                <v-radio color="green" label="Ja" value="ja"></v-radio>
                <v-radio color="green" label="Nein" value="nein"></v-radio>
              </v-radio-group>
            </div>
          </div>

          <div v-if="user_data.contact_needed === 'ja'">
            <label>
              Ansprechpartner
              <span>*/**</span>
            </label>
            <v-text-field
              placeholder="Vor- und Nachname"
              color="green"
              v-model="user_data.contact_needed_data.name"
              solo
            />

            <label>
              Telefonnummer
              <span>*/**</span>
            </label>
            <v-text-field
              placeholder="+491234567890"
              color="green"
              v-model="user_data.contact_needed_data.phone"
              solo
            />

            <label>
              Mitteilung
              <span>**</span>
            </label>
            <v-text-field
              placeholder="Nachricht"
              color="green"
              v-model="user_data.contact_needed_data.mitteilung"
              solo
            />

            <p>** Daten werden nicht im Vereinsprofil veröffentlicht.</p>
          </div>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :loading="loading"
            :disabled="!isContactNeededFilled"
            @click="updateData()"
            >LET'S GO!</v-btn
          >
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <CroppieDialog
      ref="croppieDialog"
      :image="imageSrc"
      :show.sync="showCroppie"
      @upload="cropRegistrationAvatarTeam"
    />
  </div>
</template>

<script>
import { db } from '@/db';
import croppieMixin from '../../mixins/croppie';
import pushMixin from '../../mixins/push-notifications';
import registerMixin from '../../mixins/register';
import commonMixin from '../../mixins/common';
import CroppieDialog from '../../components/dialogs/CroppieDialog';
import Axios from 'axios';
import { cloudFunctions } from '../../config';

export default {
  name: 'register-team',

  components: {
    CroppieDialog,
  },

  mixins: [croppieMixin, pushMixin, registerMixin, commonMixin],

  data: () => ({
    checkbox_anb: false,
    checkbox_datenschutz: false,
    selectedStep: 1,
    team_name: '',
    email: '',
    password: '',
    loading: false,
    discount: false,
    showPW: false,
    need: [
      { text: 'Nur Spieler', value: 'Spieler' },
      { text: 'Nur Trainer', value: 'Trainer' },
      { text: 'Spieler & Trainer', value: 'Spieler & Trainer' },
      { text: 'Kein Bedarf', value: 'Kein Bedarf' },
    ],
    rules: {
      required: (value) => !!value || '*Pflichtfeld.',
      min: (v) => v.length >= 8 || '*min. 8 Zeichen',
    },
  }),
  computed: {
    user_data() {
      return this.$store.state.user_data;
    },

    isFormValid() {
      const playerValid = this.isPlayerNeeded
        ? this.user_data.playerprofile_sex &&
          this.user_data.playerprofile_sex.length &&
          this.user_data.playerprofile_position &&
          this.user_data.playerprofile_position.length
        : true;
      const trainerValid = this.isTrainerNeeded
        ? this.user_data.trainerprofile_sex &&
          this.user_data.trainerprofile_sex.length &&
          this.user_data.trainerprofile_type &&
          this.user_data.trainerprofile_type.length
        : true;
      return this.user_data.will_be_found_by && playerValid && trainerValid;
    },

    isPlayerNeeded() {
      return (
        this.user_data.will_be_found_by === 'Spieler' ||
        this.user_data.will_be_found_by === 'Spieler & Trainer'
      );
    },

    isTrainerNeeded() {
      return (
        this.user_data.will_be_found_by === 'Trainer' ||
        this.user_data.will_be_found_by === 'Spieler & Trainer'
      );
    },

    isContactNeededFilled() {
      return this.user_data.contact_needed === 'nein'
        ? true
        : this.user_data.contact_needed_data.name &&
            this.user_data.contact_needed_data.phone;
    },
  },
  mounted() {
    window.addEventListener('beforeunload', (e) => {
      // Cancel the event
      e.preventDefault();
      // Chrome requires returnValue to be set
      e.returnValue = '';
    });

    this.user_data.contact_needed = 'ja';
  },
  beforeMount() {
    this.$gtm.push({
      event: 'registration_start',
      registration_progress: 'start',
      registration_category: 'fullyRegisterTeam',
    });
    if (localStorage.discount) {
      this.discount = true;
    }
  },
  methods: {
    back() {
      this.selectedStep--;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'fullyRegisterTeam',
      });
      window.scrollTo(0, 0);
    },

    next() {
      this.selectedStep++;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'fullyRegisterTeam',
      });
      window.scrollTo(0, 0);
    },

    updateData() {
      this.clearLinks();

      this.loading = true;

      this.user_data.fullyFilled = true;

      db.collection('teams')
        .doc(this.user_data.id)
        .update({ ...this.user_data })
        .then(() => {
          this.$gtm.push({
            event: 'registration',
            registration_progress: 'success',
            registration_category: 'fullyRegisterTeam',
          });
          this.$router.push({ name: 'team_home' });
        })
        .then(async () => {
          if (this.user_data.contact_needed === 'ja') {
            const data = {
              contactPerson: this.user_data.contact_needed_data.name,
              phone: this.user_data.contact_needed_data.phone,
              message: this.user_data.contact_needed_data.mitteilung,
              name: this.user_data.team_name,
              type: this.user_data.userType,
            };

            console.log('data to email', data);
            await Axios({
              method: 'post',
              url: `${cloudFunctions}/sendContactNeedEmail`,
              headers: {
                'content-type': 'application/json',
                'Access-Control-Allow-Origin': '*',
              },
              data,
            });
          }
        });
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/register.scss';
</style>
